// Components==============
import React from 'react';
import Bottom from './Bottom';
import Top from './Top';
import './TrophyGarden.module.scss';
// =========================

export default function TrophyGarden() {
    return (
        <div styleName="wrapper">
            <Bottom />
            <Top />
        </div>
    );
}
